import { render, staticRenderFns } from "./ChainsDetail.vue?vue&type=template&id=5f52bfac&"
import script from "./ChainsDetail.vue?vue&type=script&lang=js&"
export * from "./ChainsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports